import Vue from 'vue'
import App from './App.vue'
import Argon from "./plugins/argon-kit";

import router from '@/router/index'

Vue.config.productionTip = false
Vue.use(Argon)

import { BootstrapVue } from 'bootstrap-vue'
// import fs from './../node_modules/@'

// Install BootstrapVue
Vue.use(BootstrapVue)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
